export default function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/_lib/requiredArgs/index.js
// module id = 2
// module chunks = 0